import { Stack } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { FormikDrawerContent } from 'shared/form/FormikDrawer';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { useBypassNavigationPrompt } from 'shared/routing/NavigationBlock';
import {
  BankAccountForm,
  BankAccountLegalNotice,
  useBankAccountSetupForm,
} from '../../../profile/superpay/bank-account/BankAccountForm';
import { MobileDrawerFormLayout } from '../../../profile/superpay/MobileDrawerFormContent';
import { SUPERPAY_WEBVIEW_ROUTES } from '../../../profile/superpay/SuperPayRoute';
import { SuperPayWebviewHeader } from './SuperPayWebviewHeader';
import { useInterceptBackButton } from './useInterceptBackButton';

export function BankAccountWebViewPage() {
  const navigate = useBypassNavigationPrompt();

  const { formik, isFetching } = useBankAccountSetupForm({
    onVerificationRequired: () => {
      navigate(SUPERPAY_WEBVIEW_ROUTES.bankVerification, { replace: true });
    },
  });

  useDocumentTitle('Setup SuperPay');
  useInterceptBackButton();

  return (
    <SuperPayWebviewHeader>
      <MobileDrawerFormLayout
        action={
          <Button
            disabled={!formik.dirty}
            onClick={() => {
              void formik.submitForm();
            }}
            pending={formik.isSubmitting || isFetching}
            fullWidth={true}
          >
            Submit
          </Button>
        }
      >
        <FormikDrawerContent
          formik={formik}
          title="Bank Account"
          disableClose={true}
          disableAutoClose={true}
          actions={null}
        >
          <Stack space="small">
            <BankAccountLegalNotice />
            <BankAccountForm />
          </Stack>
        </FormikDrawerContent>
      </MobileDrawerFormLayout>
    </SuperPayWebviewHeader>
  );
}
